import { PackageEnum } from '@insurance/api/requests'
import { Form } from 'antd'

import { ContractorTypeFields } from '../PersonsFields'
import { useModifyDriversInfo } from './hooks'
import { formProps, MIN_AGE } from './utils'

export const ContractorType = () => {
  const { insurancePackageProps, fiftyFiftyFullProps } = formProps()

  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })

  const fiftyFiftyFull = Form.useWatch(fiftyFiftyFullProps.name, {
    preserve: true
  })

  const isMini = insurancePackage === PackageEnum.MINI
  const disableContractorType = isMini || fiftyFiftyFull

  useModifyDriversInfo()

  return (
    <ContractorTypeFields
      minAge={MIN_AGE}
      resident
      showSameContractorField={false}
      disableContractorType={disableContractorType}
      disableBirthDate={fiftyFiftyFull}
      disableExperience={fiftyFiftyFull}
      showBirthDate
      showExperience
    />
  )
}
